import moment from "moment";
import {
  GET_COUPONS,
  GET_COUPON_PRODUCTS,
  GET_PRODUCTS_CATEGORY,
  SET_ORDER_BY,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialCoupons = {
  coupons: [],
  couponCount: 0,
  page: 1,
  search: "",
  orderby: "desc",
  sortby: "",
  allProducts: [],
  categories: [],
};

function couponsReducer(state = initialCoupons, action) {
  switch (action.type) {
    case GET_COUPONS:
      return {
        ...state,
        coupons: action.payload.coupons?.map((coupon) => {
          const type_name =
            coupon.type === "ALL"
              ? "All Courses"
              : coupon.type === "LIVE"
              ? "Live Courses"
              : coupon.type === "RECORDED"
              ? "Recorded Courses"
              : coupon.type === "FACE-TO-FACE"
              ? "Face to Face"
              : coupon.type === "buy_x_get_x_free"
              ? "Buy X Get X Free"
              : coupon.type === "buy_specific_get_specific_free"
              ? "Buy Specific Get Specific Free"
              : coupon.type === "TUTORSHIP"
              ? "Tutorship"
              : coupon.type === "INSTRUCTOR"
              ? "Instructor"
              : coupon.type === "COMBO"
              ? "Combo"
              : null;
          return {
            ...coupon,
            type_name: type_name,
            updatedAtFormatted: moment(coupon.createdAt).format("ll"),
          };
        }),
        couponCount: action.payload.total,
      };

    case GET_COUPON_PRODUCTS:
      return {
        ...state,
        allProducts: action.payload,
      };

    case GET_PRODUCTS_CATEGORY:
      return {
        ...state,
        categories: action.payload,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
}

export default couponsReducer;
